import { useFlag } from "hooks";
import React, { useEffect, useState } from "react";
import { View, FlatList, TouchableOpacity } from "react-native";

import Text from "components/Text";
import Icon from "components/Icon";
import Separator from "components/Separator";
import ModalInfinityList from "components/ModalInfinityList";

import { colors, sizes, strings } from "assets/constants";
import { styles } from "./styles";

export default function Picker(props: PickerT) {
  const { flg: modal, on: showModal, off: hideModal } = useFlag();

  const {
    data,
    icon,
    error,
    value,
    disabled,
    onSelect,
    hideError,
    placeholder,
  } = props;
  const val = value as string;

  const [valueState, setValueState] = useState<undefined | string>();
  useEffect(() => setValueState(val), [val]);

  const _renderItem = (args: { item?: PickerItemT }) => {
    const item = args.item;
    return (
      <TouchableOpacity
        activeOpacity={sizes.tapOpacity}
        style={styles.item}
        onPress={() => {
          onSelect && onSelect(item);
          setValueState(item?.title);
          hideModal();
        }}
      >
        <Text weight={!item ? "bold" : "default"} size={!item ? "lg" : "md"}>
          {!item ? strings.pick : item.title}
        </Text>
      </TouchableOpacity>
    );
  };

  return (
    <>
      <>
        <TouchableOpacity
          disabled={disabled}
          onPress={showModal}
          style={styles.inputContainer}
          activeOpacity={sizes.tapOpacity}
        >
          <View style={styles.iconContainer}>
            <Icon name="chevron-down" />
          </View>
          <View style={styles.textContainer}>
            <Text
              color={valueState ? colors.textColorDefault : colors.placeholder}
            >
              {valueState ?? placeholder}
            </Text>
          </View>
          {icon && (
            <View style={styles.iconContainer}>
              <Icon {...icon} />
            </View>
          )}
        </TouchableOpacity>
        {!hideError && (
          <View style={styles.errorContainer}>
            <Text size={"xs"} color={colors.danger}>
              {error}
            </Text>
          </View>
        )}
      </>

      <ModalInfinityList visible={modal} close={hideModal}>
        {data && data?.length > 0 && (
          <FlatList
            nestedScrollEnabled
            maxToRenderPerBatch={10}
            data={[undefined, ...data]}
            keyExtractor={(_, key) => String(key)}
            renderItem={_renderItem}
            style={{ width: "100%" }}
            showsVerticalScrollIndicator={false}
            ItemSeparatorComponent={() => <Separator size={"80%"} />}
          />
        )}
      </ModalInfinityList>
    </>
  );
}
